const escapeCsvCell = (value: unknown): string => {
  if (value === null || value === undefined) return '""';

  const normalizedValue =
    typeof value === "string"
      ? value
      : typeof value === "boolean"
        ? String(value)
        : String(value);

  return `"${normalizedValue.replace(/"/g, '""')}"`;
};

export const createCsvContent = (headers: Array<string>, rows: Array<Array<unknown>>) => {
  const headerRow = headers.map(escapeCsvCell).join(",");
  const dataRows = rows.map((row) => row.map(escapeCsvCell).join(","));

  return [headerRow, ...dataRows].join("\r\n");
};

export const downloadCsvFile = (filename: string, content: string) => {
  const blob = new Blob(["\uFEFF", content], {
    type: "text/csv;charset=utf-8;",
  });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};
